import { Injectable } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import { AssetClassType } from '@ddt-web/common';
import { UrlUtils } from '@ddt-web/url';

import { CellData } from '../models';
import { CellUtil } from '../utils';

@Injectable({
	providedIn: 'root'
})
export class ProductPageLinkResolverService {

	private productPageUrl;
	private productCashPageUrl;
	private productTickerSearchUrl;

	constructor(private hrefResolverService: HrefResolverService) {
		try {
			this.productPageUrl = this.hrefResolverService.getResolvedUrl('productPageUrl');
			this.productCashPageUrl = this.hrefResolverService.getResolvedUrl('productCashPageUrl');
			this.productTickerSearchUrl = this.hrefResolverService.getResolvedUrl('productTickerSearchUrl');
		} catch (e) {
			console.log('No value exists in hrefResolver map');
		}
	}

	public getUrlByCellData(cellData: CellData[], cellIdToFind: string, portfolioId: string): string {
		const assetType = CellUtil.getFormattedCellValueById(cellData, cellIdToFind) as string;
		return this.getUrlByAssetType(assetType, portfolioId);
	}

	public getUrlByAssetType(assetType: string, id: string): string {
		if (!id) {
			return '';
		}

		id = id.toString().toUpperCase();

		if (this.productCashPageUrl && assetType === AssetClassType.CASH) {
			return this.replaceUrlWithId(this.productCashPageUrl, id);
		}

		const isTicker = /^[A-Z]+$/.test(id);
		if (this.productTickerSearchUrl && isTicker) {
			return this.replaceUrlWithId(this.productTickerSearchUrl, id);
		}

		const isCusip = /^[A-Z0-9]{9}$/.test(id);
		if (this.productTickerSearchUrl && isCusip) {
			return this.replaceUrlWithId(this.productTickerSearchUrl, id);
		}

		const isPortfolioId = /^\d+$/.test(id);
		if (this.productPageUrl && isPortfolioId) {
			return this.replaceUrlWithId(this.productPageUrl, id);
		}

		const isAggregateKey = /^[A-Z]+@.+@.+$/.test(id);
		if (this.productTickerSearchUrl && isAggregateKey) {
			const [ticker, ,] = id.split('@');
			return this.replaceUrlWithId(this.productTickerSearchUrl, ticker);
		}

		// ticker search handles all identifiers according to cwp
		return this.productTickerSearchUrl ? this.replaceUrlWithId(this.productTickerSearchUrl, id) : '';
	}

	private replaceUrlWithId(url: string, id: string): string {
		url = decodeURIComponent(url)
			.replace(new RegExp(/&amp;?/g), '&')
			.replace('$id', id);

		return UrlUtils.removeDuplicateSlashes(url);
	}

}
